import { IDefaultTranslationContent, ParameterizedTranslation } from '../mixins';
import { Auth0Error } from 'auth0-js';

import { ILogo } from '../components/WLHeader/types';

export function isParameterizedTranslation(
  translation: IDefaultTranslationContent['key'],
): translation is ParameterizedTranslation {
  return typeof translation === 'function';
}
export function isLogo(param: ILogo | string): param is ILogo {
  return typeof param !== 'string';
}

export function isAuthError(error: any): error is Auth0Error {
  return !!(error && (error as Auth0Error).code);
}
